// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import { accountReducer } from "./slices/accountSlice";
import { datasetReducer } from "./slices/datasetSlice";
import { permissionReducer } from "./slices/permissionSlice";
import { roleReducer } from "./slices/roleSlice";
import { semanticReducer } from "./slices/semanticSlice";
import { templateReducer } from "./slices/templateSlice";
import { toastReducer } from "./slices/toastSlice";
import { userReducer } from "./slices/userSlice";
import {exportTriggerReducer} from "./slices/exportTriggerSlice";
import { documentReducer } from "./slices/documentSlice";
import { namingIssueReducer } from "./slices/namingIssueSlice";
import { firmReducer } from './slices/firmSlice';
import { appUiReducer } from './slices/appUi';
import { docTypeAliasMappingReducer } from './slices/docTypeAliasMappingSlice';
import { archivedDocumentReducer } from './slices/archivedDocumentSlice';
import {dashboardReducer} from "./slices/dashboard";
import { fwfTemplateReducer } from "./slices/fwfTemplateSlice";

export const store = configureStore({
  reducer: {
    role: roleReducer,
    user: userReducer,
    permission: permissionReducer,
    toast: toastReducer,
    account: accountReducer,
    document: documentReducer,
    namingIssue: namingIssueReducer,
    firm:firmReducer,
    docTypeAliasMapping:docTypeAliasMappingReducer,
    archivedDocument:archivedDocumentReducer,
    fwfTemplate: fwfTemplateReducer,
    appUi:appUiReducer,
    semantic: semanticReducer,
    dataset: datasetReducer,
    template: templateReducer,
    exportTrigger: exportTriggerReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
